import { useMutation, useQueryClient } from "@tanstack/react-query";

import { exploreImagesQueryKey } from "@/hooks/queries/useGetExploreImages";
import { guacHttpClient } from "@/lib/http";
import { ExploreImage, HttpResponse, PositionCategory } from "@/types";

export function useUploadExploreImage() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      image,
      positionCategory,
    }: {
      image: File;
      positionCategory: PositionCategory;
    }) => {
      const res = await guacHttpClient.postForm<
        ExploreImage,
        HttpResponse<ExploreImage>
      >("explore-images", { image, positionCategory });

      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: exploreImagesQueryKey });
    },
  });

  return mutation;
}
